module.exports = __webpack_public_path__ + "img/contact us pic@2x.80611743.png";